// removed by extract-text-webpack-plugin
module.exports = {"econom":"_1z1EGKI0EQC5B7kPplKhOc","tg":"z9BJeDlZMawbBBjuiIBTw","tgF6ar":"mDYK39sNGJw4rs7WeO6By","tgT3d6":"HgH0eAIZ8Rufo5tRiH6Wl","tgCxkv":"_1f7PXsq5Q-QYPAmndQbu_T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/Economentry/style.css
// module id = 282
// module chunks = 0